import cn from 'classnames';
import type { PropsWithChildren } from 'react';
import React from 'react';

import CircularProgress from './CircularProgress';
import styles from './styles.module.scss';

export type Version = 'contained' | 'outlined';

export interface SubmitButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    progress: boolean;
    version?: Version;
}

const SubmitButton: React.FC<PropsWithChildren<SubmitButtonProps>> = ({
    children,
    className,
    progress,
    version = 'contained',
    ...rest
}) => {
    return (
        <button {...rest} className={cn(styles.button, styles[version], className)} type='submit' disabled={progress}>
            {progress ? <CircularProgress version={version} /> : children}
        </button>
    );
};

export default SubmitButton;
